import React, { useState } from 'react';
import styled from 'styled-components';
import { Alert, Dialog, Link, MessagePlugin, Radio, Upload } from 'tdesign-react';
import { downloadFile } from '@/utils/common';
import { downloadHostExcel, importHostExcel, uploadHostPrvKey } from '@/services/resourceService';
import Form from '@/components/Form';

const { FormItem } = Form;

export default function ImportModal({ visible, handleClose, clusterId }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const type = Form.useWatch('type', form);

  const handleSubmit = async (values) => {
    const { file, hostZip } = values;

    try {
      setSubmitting(true);
      // 先上传秘钥
      if (type === '2') {
        const formData = new FormData();
        formData.append('file', hostZip[0].raw);
        await uploadHostPrvKey(formData);
      }
      // 然后上传模板
      const formData = new FormData();
      formData.append('file', file[0].raw);
      await importHostExcel({ clusterId, type }, formData);
      MessagePlugin.success('上传成功！');
      handleClose(true);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  const download = async () => {
    const resp = await downloadHostExcel(type);
    const typeText = type === '1' ? '密码验证' : '公钥验证';
    downloadFile(
      new Blob([resp], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
      `主机导入模板(${typeText}).xlsx`,
    );
  };

  return (
    <Dialog
      header='Excel导入'
      visible={visible}
      onClose={() => handleClose(true)}
      onConfirm={() => form.submit()}
      placement='center'
      confirmBtn={{
        loading: submitting,
        content: '确认',
      }}
      destroyOnClose
      width={600}
    >
      <Root>
        <Alert
          message='请下载使用该模板填充数据后导入'
          theme='info'
          operation={
            <Link theme='primary' hover='color' onClick={download}>
              主机导入模板.xlsx
            </Link>
          }
        />
        <Form
          form={form}
          onFinish={handleSubmit}
          style={{ marginTop: 16 }}
          initialValues={{ type: '1' }}
        >
          <FormItem name='type' label='验证方式' rules={[{ required: true }]}>
            <Radio.Group>
              <Radio.Button value='1'>密码验证</Radio.Button>
              <Radio.Button value='2'>密钥验证</Radio.Button>
            </Radio.Group>
          </FormItem>
          <FormItem name='file' label='导入数据' rules={[{ required: true }]}>
            <Upload
              theme='file'
              accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
              autoUpload={false}
            />
          </FormItem>
          {type === '2' && (
            <FormItem name='hostZip' label='导入秘钥' rules={[{ required: true }]}>
              <Upload
                theme='file'
                accept='application/x-tar,application/zip,application/gzip'
                autoUpload={false}
              />
            </FormItem>
          )}
        </Form>
      </Root>
    </Dialog>
  );
}

const Root = styled.div`
  .t-alert__description {
    flex: 1;
  }
`;
